
import {useState} from "react";
import {cloneDeep, find, isInteger, findIndex, get} from "lodash";
import {addWeeks} from "date-fns";
import FormWrapper from "./FormWrapper";
import PriceCheckbox from "./PriceCheckbox";
import DatePicker from "react-datepicker";
import { LiaCalendar } from "react-icons/lia";


import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import {euroPrice} from "../utils";
import {NumericFormat} from "react-number-format";

import formData from "../data/assembled.json";
import Field from "./Field";
import Upload from "./Upload";
import hotkeys from "hotkeys-js";
import {BarLoader} from "react-spinners";

const FORM_ID = 'nobilia-form';

const MIN_SIZE = formData.minSize;
const DEFAULT_CHECKBOX_FIELDS = formData.defaultCheckboxFields;
const TEST_CHECKBOX_FIELDS = formData.testCheckboxFields;
const FLOOR_PRICE = formData.floorPrice;

const LOCATION_OPTIONS = [
    {value: 'Vertragen mit Fahrstuhl', label: 'Fahrstuhl vorhanden', elevator: true, floor: 0},
    {value: 'Vertragen ohne Fahrstuhl (Etage 0)', label: 'Kein Fahrstuhl - Küche in Etage 0', floor: 0},
    {value: 'Vertragen ohne Fahrstuhl (Etage 1)', label: 'Kein Fahrstuhl - Küche in Etage 1', floor: 1},
    {value: 'Vertragen ohne Fahrstuhl (Etage 2)', label: 'Kein Fahrstuhl - Küche in Etage 2', floor: 2},
    {value: 'Vertragen ohne Fahrstuhl (Etage 3)', label: 'Kein Fahrstuhl - Küche in Etage 3', floor: 3},
    {value: 'Vertragen ohne Fahrstuhl (Etage 4)', label: 'Kein Fahrstuhl - Küche in Etage 4', floor: 4},
    {value: 'Vertragen ohne Fahrstuhl (Etage 5)', label: 'Kein Fahrstuhl - Küche in Etage 5', floor: 5},
    {value: 'Vertragen ohne Fahrstuhl (Etage 6)', label: 'Kein Fahrstuhl - Küche in Etage 6', floor: 6},
    {value: 'Vertragen ohne Fahrstuhl (Etage 7)', label: 'Kein Fahrstuhl - Küche in Etage 7', floor: 7},
    {value: 'Vertragen ohne Fahrstuhl (Etage 8)', label: 'Kein Fahrstuhl - Küche in Etage 8', floor: 8},
    {value: 'Vertragen ohne Fahrstuhl (Etage 9)', label: 'Kein Fahrstuhl - Küche in Etage 9', floor: 9}
];

function AssembledForm() {
    const minDate = addWeeks(new Date(), 5);

    const [assemblyUnitPrice, setAssemblyUnitPrice] = useState(null);
    const [elevator, setElevator] = useState(false);
    const [floor, setFloor] = useState(null);
    const [startDate, setStartDate] = useState(minDate);
    const [size, setSize] = useState('');
    const [checkboxFields, setCheckboxFields] = useState(DEFAULT_CHECKBOX_FIELDS);
    const [locationValue, setLocationValue] = useState(null);
    const [files, setFiles] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);

    function setCheckboxFieldsByOption(option){
        const fields = cloneDeep(checkboxFields);
        const i = findIndex(fields, {name: 'floor'});

        fields[i].price = Math.max(0, option.floor-1) * FLOOR_PRICE;

        if(option.elevator){
            fields[i].label = 'Vertrag mit Fahrstuhl';
        }
        else{
            fields[i].label = `Vertragen ohne Fahrstuhl (Etage ${option.floor})`;
        }

        setCheckboxFields(fields);
    }

    function setAssemblyCheckbox(newSize, newUnitPrice){
        const f = cloneDeep(checkboxFields);
        let assemblyField = find(f, {name: 'assembly'});
        assemblyField.price = newSize * get(newUnitPrice, 'price', formData.assemblyUnitPrices[0].price);
        assemblyField.label = `Küchenmontage (${newSize} lfm.)`;
        setCheckboxFields(f);
    }

    // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    hotkeys('ctrl+n', function(event, handler){
        setSize(4.5);
        setElevator(false);
        setFloor(1);
        setAssemblyUnitPrice(formData.assemblyUnitPrices[0]);
        setLocationValue(LOCATION_OPTIONS[2]);
        setCheckboxFields(TEST_CHECKBOX_FIELDS);

        const form = document.getElementById(FORM_ID);
        form.querySelector('input[name="first_name"]').value = 'Max';
        form.querySelector('input[name="last_name"]').value = 'Mustermann';
        form.querySelector('input[name="company"]').value = 'Unternehmen ABC';
        form.querySelector('input[name="email"]').value = 'kontakt@abc.de';
        form.querySelector('input[name="phone"]').value = '+49 123 456 7890';
        form.querySelector('textarea[name="message"]').value = 'Lorem ipsum...';
    });
    // }


    const getTotalPrice = () => {
        let sum = 0;

        checkboxFields.forEach(field => {
            if(field.selected){
                sum += field.price;
            }
        });

        return sum;
    }

    const sizeNextButtonDisabled = isNaN(parseFloat(size)) || parseFloat(size)<MIN_SIZE;


    return <FormWrapper
        url={process.env.REACT_APP_ASSEMBLED_FORM_URL}
        formId={FORM_ID}
        files={files}
        onError={(message) => setErrorMessage(message)}
        onSubmit={()=>setErrorMessage(null)}
    >

        <fieldset key="product_value" className='fieldset-product-value'>
            <input type="hidden" name={'price_category'} value={get(assemblyUnitPrice, 'value', '')}/>

            <header>Bitte geben Sie den Bruttoauftragswert<sup>*</sup> ein.</header>

            <Field>
                <Select placeholder={'Bitte auswählen...'}
                        name={'product_value'}
                        options={formData.assemblyUnitPrices}
                        value={assemblyUnitPrice}
                        required
                        isClearable={false}
                        isSearchable={false}
                        onChange={(option) => {
                            setAssemblyUnitPrice(option);
                            setAssemblyCheckbox(size, option);
                        }}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderRadius: 40,
                                fontSize: 'var(--montas-font-size-medium)',
                                padding: '0 var(--montas-space-xs)',
                                border: 0,
                                boxShadow: 'none'
                            }),
                            indicatorSeparator: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'none'
                            }),
                            dropdownIndicator: (baseStyles, state) => ({
                                ...baseStyles,
                                '& svg': {
                                    width: 24,
                                    height: 24
                                },
                            })
                        }}
                />

                <div className="instruction">
                    <sup>*</sup>Bruttoauftragswert inkl. MwSt. und Montage.
                </div>
            </Field>


            {assemblyUnitPrice && assemblyUnitPrice.value===4 && (
                <div className={'assembled-custom-price-notice'}>
                    <p>
                        Die Montage von Küchen mit Bruttoauftragswert ab 30.000 €
                        findet nur auf Individualanfrage statt.
                    </p>

                    <p>
                        Wir unterbreiten Ihnen gerne ein individuelles Angebot.
                        Nutzen Sie bitte dafür unser Kontaktformular.
                    </p>

                    <div style={{marginTop: 16}}>
                        <button onClick={(event)=>{
                            event.preventDefault();

                            if(window.parent){
                                window.parent.postMessage('mnts_custom_assembled_click', 'https://montas.de');
                            }
                        }}>
                            zum Kontakt
                        </button>
                    </div>
                </div>
            )}

            <button className="next-fieldset fieldset-primary-button"
                    disabled={assemblyUnitPrice==null}
                    style={{display: (assemblyUnitPrice==null || (assemblyUnitPrice && assemblyUnitPrice.value!==4)) ? 'block' : 'none'}}
            >
                Weiter
            </button>
        </fieldset>

        <fieldset key="size" className='fieldset-size'>
            <header>Bitte geben Sie die laufenden Meter<sup>*</sup> an.</header>


            <Field>
                <input type="hidden" name={'size'} value={size}/>

                <NumericFormat
                    id="nobilia-size"
                    name="size_numeric_format"
                    value={size}
                    required
                    decimalScale={1}
                    min={3} max={10} step={0.1}
                    placeholder={'3,0'}
                    decimalSeparator=","
                    allowNegative={false}
                    fixedDecimalScale
                    onChange={(event)=>{
                        const s = event.target.value.replace(',', '.');
                        setAssemblyCheckbox(s, assemblyUnitPrice);
                        setSize(s);
                    }}
                />
                <label htmlFor="nobilia-size">lfm.</label>

                <div className="instruction">
                    <sup>*</sup> lfm. der Küchenrückseite, Inseln zählen doppelt, berechnet werden angefangene 10 cm; mindestens jedoch 3,0 lfm.
                </div>
            </Field>


            <button className="next-fieldset fieldset-primary-button" disabled={sizeNextButtonDisabled}>
                Weiter zu den örtlichen Gegebenheiten
            </button>
        </fieldset>



        <fieldset key="floor" className='fieldset-floor'>
            <header>Bitte geben Sie Infos zu den örtlichen Gegebenheiten an.</header>

            <input type="hidden" name={'elevator'} value={elevator ? '1': '0'}/>
            <input type="hidden" name={'floor'} value={floor===null ? '' : floor}/>

            <Field>
                <Select placeholder={'Bitte auswählen...'}
                        name={'floor_select'}
                        classNamePrefix={'floor-select'}
                        options={LOCATION_OPTIONS}
                        value={locationValue}
                        required
                        isClearable={false}
                        isSearchable={false}
                        formatOptionLabel={({value,label}, {context})=> context==='value' ? label.replace(' - ', '\n') : label}
                        onChange={(option) => {
                            setLocationValue(option);
                            setFloor(option.floor);
                            setElevator(option.elevator);
                            setCheckboxFieldsByOption(option);
                        }}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderRadius: 40,
                                fontSize: 'var(--montas-font-size-medium)',
                                padding: '0 var(--montas-space-xs)',
                                border: 0,
                                boxShadow: 'none'
                            }),
                            indicatorSeparator: (baseStyles, state) => ({
                                ...baseStyles,
                                display: 'none'
                            }),
                            dropdownIndicator: (baseStyles, state) => ({
                                ...baseStyles,
                                '& svg': {
                                    width: 24,
                                    height: 24
                                },
                            })
                        }}
                />

                <div className="instruction">
                    Bitte wählen sie das Zutreffende aus dem Dropdown Menü aus.
                </div>
            </Field>

            <button className="next-fieldset fieldset-primary-button" disabled={!isInteger(floor)}>
                Jetzt Preis berechnen
            </button>
        </fieldset>







        <fieldset key="summary" className={'fieldset-summary'}>
            <header>Angebot Full-Service-Montage<sup style={{fontSize: '50%', opacity: 0.67}}>1</sup></header>

            <div className='col checkboxes'>
                {
                    checkboxFields.map((field, index) => (<PriceCheckbox fieldName={field.name} label={field.label}
                                                                         price={field.price}
                                                                         checked={field.selected}
                                                                         disabled={field.disabled}
                                                                         key={field.name}
                                                                         instructionLabel={field.instructionLabel}
                                                                         onChange={() => {
                                                                             const f = cloneDeep(checkboxFields);
                                                                             f[index].selected = !f[index].selected;
                                                                             setCheckboxFields(f);
                                                                         }}
                    />))
                }
            </div>


            <div className="col price">
                <div className={'total-price'}>
                    <span className={'headline'}>Gesamtpreis</span>
                    <div>
                        <span className="value">{euroPrice(getTotalPrice())}</span>
                        <span className="tax">zzgl. MwSt.</span>
                    </div>
                    <div className={'delivery-time-tip'}>
                        <LiaCalendar />
                        Montagetermin i.d.R. innerhalb der Herstellerlieferzeit plus 1-2 Wochen.
                    </div>
                </div>

                <button className="next-fieldset fieldset-primary-button">
                    Jetzt mit Wunschtermin anfragen
                </button>
            </div>

            <div className="instructions">
                <ol>
                    <li>Für Einzelmontagen. Objektmontagen auf Anfrage.</li>
                    {
                        checkboxFields.map((field, index) => {
                            return field.instruction && (
                                <li key={field.name}>
                                    {field.instruction}
                                </li>
                            );
                        })
                    }
                </ol>
            </div>
        </fieldset>



        <fieldset key="contact" className={'contact'}>
            <header>Anfrage Full-Service-Montage</header>

            <div className="fields">

                <div className="field w-50">
                    <label>
                        <span>Vorname</span>
                        <input type="text" required={true} name={'first_name'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Nachname</span>
                        <input type="text" required={true} name={'last_name'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Wunschmontagewoche</span>
                        <DatePicker
                            name={'date'}
                            selected={startDate}
                            minDate={minDate}
                            locale={'de'}
                            dateFormat="'KW 'w"
                            showWeekNumbers={true}
                            weekLabel={"KW"}
                            showWeekPicker={true}
                            onChange={(date) => setStartDate(date)}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                        />
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Firma</span>
                        <input type="text" required={false} name={'company'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>E-Mail-Adresse</span>
                        <input type="email" required={true} name={'email'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Telefonnummer</span>
                        <input type="text" required={true} name={'phone'}/>
                    </label>
                </div>

                <div className="field">
                    <label>
                        <span>Montageort und weitere Hinweise</span>
                        <textarea name="message" rows="5" style={{resize: "none"}} maxLength={500}/>
                    </label>
                </div>
            </div>

            <div className="col">
                <div className="upload-panel">
                    <span className='headline'>Möchten Sie Pläne etc. hochladen?</span>
                    <p className={'instruction'}>Bis zu drei Dateien (JPG, PNG, PDF). Maximal 5MB pro Datei.</p>
                    <Upload onFilesChange={(files)=>setFiles(files)}/>
                </div>

                <button className={'fieldset-primary-button submit-button'}>
                    <span>Anfrage senden</span>
                    <BarLoader
                        className={'loader-animation'}
                        color="#ffffff"
                        height={2}
                        speedMultiplier={1}
                    />
                </button>

                {errorMessage && (
                    <div className="form-response---error-message">
                        {errorMessage}
                    </div>
                )}
            </div>

            <p className="legal-notice">
                Mit dem Absenden des Kontaktformulars verarbeiten und speichern wir Ihre Daten zur Bearbeitung Ihres Anliegens.
                In unserer <a href={"https://montas.de/datenschutz"} target={"_blank"} rel='noreferrer'>Datenschutzerklärung</a> finden Sie unsere Richtlinien zur Datenverarbeitung und Widerrufshinweise.
                Die Dienstleistungsangebote der montas GmbH richten sich ausschließlich an Unternehmer im Sinne von § 14 BGB.
            </p>
        </fieldset>
    </FormWrapper>;
}

export default AssembledForm;